import React, { FC, useMemo } from 'react';
import { Text } from '@mofid-securities/uikit';
import {
  IInteractiveNavChartTooltipItem,
  InteractiveNavChart,
  InteractiveNavChartTooltip,
  returnTooltipLabel,
  TNavChartRenderTooltip,
  usePeriods,
} from '@/components/InteractiveNavChart';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetAssetTrend } from '@/modules/invest/hooks/useGetNavChartData';

const renderTooltip: TNavChartRenderTooltip = (chart) => {
  const tooltipItems = chart?.points.map((item: any) => ({
    ...returnTooltipLabel(item?.series?.name),
    value: item?.y,
  }));

  const interactiveNavChartTooltipItems: IInteractiveNavChartTooltipItem[] = [
    {
      title: 'تاریخ',
      value: chart.x,
      type: 'date',
    },
    ...tooltipItems,
  ];

  return <InteractiveNavChartTooltip items={interactiveNavChartTooltipItems} />;
};

interface ISingleFundAssetTrendNavChartProps {}

export const SingleFundAssetTrendNavChart: FC<
  ISingleFundAssetTrendNavChartProps
> = () => {
  const { periods, selectedPeriod, setSelectedPeriod } = usePeriods();

  const fundCode = useGetFundCodeFromQuery();

  const { data, isFetching, error, refetch } = useGetAssetTrend({
    fundCode,
    fromMonthAgo: selectedPeriod.month,
  });

  const series = useMemo(
    () => [
      {
        name: 'Investment',
        color: '#80D3CB',
        type: 'area',
        data: data?.items?.map((item) => [item.d, item.a]),
      },
      {
        name: 'Issuance',
        color: 'transparent',
        type: 'line',
        data: data?.items?.map((item) => [item.d, item.iCh]),
      },
      {
        name: 'Redemption',
        color: 'transparent',
        type: 'line',
        data: data?.items?.map((item) => [item.d, item.reCh]),
      },
      {
        name: 'Reinvest',
        color: 'transparent',
        type: 'line',
        data: data?.items?.map((item) => [item.d, item.riCh]),
      },
    ],
    [data?.items]
  );

  return (
    <>
      <Text
        className="text-gray-filled-secondary-enabled"
        component="h4"
        size="sm"
        weight="demibold"
      >
        نمودار تغییرات دارایی
      </Text>
      <InteractiveNavChart
        analytics={{
          chart: {
            id: 'Funds_change_aFundassetTrendChart',
            analytics: ['Funds_change_aFundassetTrendChart'],
          },
          period: {
            id: 'Funds_change_aFundassetTrendChartDate',
            analytics: ['Funds_change_aFundassetTrendChartDate'],
          },
        }}
        error={error}
        isEmpty={!data || data?.items.length < 2}
        isLoading={isFetching}
        periods={periods}
        renderTooltip={renderTooltip}
        selectedPeriod={selectedPeriod}
        series={series}
        startDate={data?.assetTrendTotal?.firstTransactionDate}
        onErrorRetry={refetch}
        onPeriodChange={setSelectedPeriod}
      />
    </>
  );
};
